// 本地测试
// const baseSite = 'http://192.168.81.145:81'
// const host = '192.168.81.145:81'
// const baseSite = 'https://szwx-miniapps.suizhi.com/cec/ms'
// const host = 'szwx-miniapps.suizhi.com/cec/ms'
// const wxloginRedirectUri = encodeURIComponent('https://szwx-miniapps.suizhi.com/cec/vw/#/login/signIn')
// const wxBindRedirectUri = encodeURIComponent('https://szwx-miniapps.suizhi.com/cec/vw/#/personal')
// 开发测试
// const baseSite = 'http://localhost:54782'
// const host = '192.168.81.145:54782'
// const wxloginRedirectUri = encodeURIComponent('https://szwx-miniapps.suizhi.com/cec/vw/#/login/signIn')
// const wxBindRedirectUri = encodeURIComponent('https://szwx-miniapps.suizhi.com/cec/vw/#/personal')
// 生产环境
const baseSite = 'https://kaihui.suizhi.com/ms'
const host = 'kaihui.suizhi.com'
const wxloginRedirectUri = encodeURIComponent('https://kaihui.suizhi.com/v/#/login/signIn')
const wxBindRedirectUri = encodeURIComponent('https://kaihui.suizhi.com/v/#/personal')
const wxCancelAccountRedirectUri = encodeURIComponent('https://kaihui.suizhi.com/v/#/cancelAccount')
const wxAppId = 'wxf3075ddb72d28f9b'
const wxSnsapiLogin = 'snsapi_login'
const loadingText = '拼命加载中'
const loadingSpinner = 'el-icon-loading'
const loadingBackground = 'rgba(255, 255, 255, .8)'
const enableVote = true
const enableWJ = true

export default {
  baseSite,
  host,
  wxloginRedirectUri,
  wxBindRedirectUri,
  wxCancelAccountRedirectUri,
  wxAppId,
  wxSnsapiLogin,
  loadingText,
  loadingSpinner,
  loadingBackground,
  enableVote,
  enableWJ
}
